"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _SignupFormLanguage = _interopRequireDefault(require("./SignupFormLanguage"));

var _SignupTitleBlock = _interopRequireDefault(require("./SignupTitleBlock"));

var _SignupDescription = _interopRequireDefault(require("./SignupDescription"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTitleRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));

var StyledSelectWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var StyledFormRowText = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.25rem;\n  font-family: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.colorLabel;
});

var SignupForm = function SignupForm(_ref) {
  var question = _ref.question,
      dpgEmail = _ref.dpgEmail,
      translations = _ref.translations,
      dialingCode = _ref.dialingCode,
      isValid = _ref.isValid,
      showFallbackDatePicker = _ref.showFallbackDatePicker,
      values = _ref.values,
      errors = _ref.errors,
      touched = _ref.touched,
      dirty = _ref.dirty,
      signupError = _ref.signupError,
      termsSlug = _ref.termsSlug,
      language = _ref.language,
      onLanguageChanged = _ref.onLanguageChanged,
      onPageButtonClicked = _ref.onPageButtonClicked,
      handleChange = _ref.handleChange,
      handleBlur = _ref.handleBlur,
      handleSubmit = _ref.handleSubmit,
      isSubmitting = _ref.isSubmitting,
      setFieldValue = _ref.setFieldValue,
      setValues = _ref.setValues;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledTitleRow, null, /*#__PURE__*/_react.default.createElement(_SignupTitleBlock.default, null, translations.justOneStep), /*#__PURE__*/_react.default.createElement(_SignupFormLanguage.default, {
    onChange: function onChange(language) {
      return onLanguageChanged(language);
    },
    value: language
  })), /*#__PURE__*/_react.default.createElement(_SignupDescription.default, null, translations.messageFillInForm), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    disabled: true,
    value: dpgEmail
  })), /*#__PURE__*/_react.default.createElement(StyledFormRowText, null, translations.emailUsageReason), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    name: "name",
    isMandatory: true,
    placeholder: translations.nickname,
    value: values.name,
    isError: values.name !== "" && errors.name,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: values.name !== "" && errors.name
  }, errors.name), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(StyledSelectWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormSelect, {
    isMandatory: true,
    isError: values.favClub !== "" && errors.favClub,
    name: "favClub",
    value: values.favClub,
    placeholder: translations.favouriteClub,
    onChange: handleChange
  }, /*#__PURE__*/_react.default.createElement("option", null), /*#__PURE__*/_react.default.createElement("option", null, "Ajax"), /*#__PURE__*/_react.default.createElement("option", null, "AZ Alkmaar"), /*#__PURE__*/_react.default.createElement("option", null, "Den Haag"), /*#__PURE__*/_react.default.createElement("option", null, "FC Emmen"), /*#__PURE__*/_react.default.createElement("option", null, "Feyenoord"), /*#__PURE__*/_react.default.createElement("option", null, "Fortuna Sittard"), /*#__PURE__*/_react.default.createElement("option", null, "Groningen"), /*#__PURE__*/_react.default.createElement("option", null, "Heerenveen"), /*#__PURE__*/_react.default.createElement("option", null, "Heracles"), /*#__PURE__*/_react.default.createElement("option", null, "PEC Zwolle"), /*#__PURE__*/_react.default.createElement("option", null, "PSV"), /*#__PURE__*/_react.default.createElement("option", null, "RKC Waalwijk"), /*#__PURE__*/_react.default.createElement("option", null, "Sparta"), /*#__PURE__*/_react.default.createElement("option", null, "Twente"), /*#__PURE__*/_react.default.createElement("option", null, "Utrecht"), /*#__PURE__*/_react.default.createElement("option", null, "Vitesse"), /*#__PURE__*/_react.default.createElement("option", null, "VVV"), /*#__PURE__*/_react.default.createElement("option", null, "Willem II")))), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: values.favClub !== "" && errors.favClub
  }, errors.favClub), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormDatePicker, {
    isMandatory: true,
    isFallback: showFallbackDatePicker,
    isError: values.birthDate !== "" && errors.birthDate,
    name: "birthDate",
    label: translations.birthDate,
    value: values.birthDate,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: values.birthDate !== "" && errors.birthDate
  }, errors.birthDate), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
    helpTooltip: translations.helpMobileNumber
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    name: "mobileNumber",
    type: "tel",
    isMandatory: true,
    prefix: "+".concat(dialingCode),
    placeholder: translations.mobileNumber,
    value: values.mobileNumber,
    isError: values.mobileNumber !== "" && errors.mobileNumber,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: values.mobileNumber !== "" && errors.mobileNumber
  }, errors.mobileNumber), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
    helpTooltip: translations.helpPin
  }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
    name: "pin",
    type: "password",
    pattern: "[0-9]*",
    inputMode: "numeric",
    isMandatory: true,
    placeholder: "".concat(translations.personalCodePlaceholder),
    value: values.pin,
    isError: values.pin !== "" && errors.pin,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: values.pin !== "" && errors.pin
  }, errors.pin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    alignItems: "center",
    label: translations.confirm18,
    name: "agreedTerms",
    checked: values.agreedTerms,
    onChange: handleChange,
    labelLinkText: translations.termsConditionsPrivacy,
    onLabelLinkClicked: function onLabelLinkClicked() {
      return onPageButtonClicked(termsSlug, translations.termsConditions, true);
    }
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    alignItems: "center",
    label: language === "en" ? "Yes, I would like to be kept informed about this promotion and other AD promotions by e-mail." : question === null || question === void 0 ? void 0 : question.question_text,
    name: "adSubscribe",
    checked: values.adSubscribe,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    alignItems: "center",
    label: translations.confirmMarketing,
    name: "emailNotificationsAccepted",
    checked: values.emailNotificationsAccepted,
    onChange: handleChange
  })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
    isVisible: signupError
  }, signupError), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    type: "submit",
    disabled: !isValid || !dirty,
    isLoading: isSubmitting,
    style: {
      marginBottom: "1rem"
    }
  }, translations.continue), process.env.NODE_ENV === "development" || process.env.REACT_APP_IS_TOTO_TEST ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    isDefault: true,
    style: {
      marginBottom: "1rem"
    },
    to: "/login"
  }, "Login") : null);
};

var _default = SignupForm;
exports.default = _default;